<a uiSref="{{getUISref()}}"
    [uiParams]="{ complianceItemId: complianceItem.ItemID, page: 1 }"
    *accessControl="getAccessControl(); entityOwner: complianceItem.CreatedBy; ifCondition: isLink() && shouldShowButton()"
    [ngClass]="getClasses()">{{this.getLabel()}}</a>
<button
    [ngClass]="getClasses()"
    (click)="onClick()"
    *accessControl="getAccessControl(); entityOwner: complianceItem.CreatedBy; ifCondition: !isLink() && shouldShowButton()">{{this.getLabel()}}</button>
